/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { getPayloadObject, getTelemetryAttributes, IPayLoad, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import classnames from 'classnames';

export interface ICookieComplianceCustomizeButton {
    reloading?: boolean;
    customizeCookiesButtonText?: string;
    customizeCookiesButtonAriaLabel?: string;

    /**
     * The telemetry content
     */
    telemetryContent?: ITelemetryContent;
    onClose(): void;
}

export const CookieComplianceCustomizeButton: React.FC<ICookieComplianceCustomizeButton> = ({
    reloading,
    customizeCookiesButtonText,
    customizeCookiesButtonAriaLabel,
    telemetryContent,
    onClose
}) => {
    const payLoad: IPayLoad = getPayloadObject('click', telemetryContent!, 'customize cookies');
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);

    return (
        <button
            type='button'
            className={classnames('ms-cookie-compliance__customize-button msc-btn', { 'is-loading': reloading })}
            aria-label={customizeCookiesButtonAriaLabel}
            disabled={reloading}
            onClick={onClose}
            {...attributes}
        >
            {customizeCookiesButtonText}
        </button>
    );
};
